import {
  AuthVerifyOtpDto,
  AuthLoginDto,
  AuthLogoutDto,
  AuthRefreshDto,
  AuthCreateDto,
  EmployerCreateDto,
  JobseekerCreateDto,
  LoginResponseDto,
} from '@libs/dto';
import { AuthToken, Jobseeker, User } from '@libs/models';

import { api } from '../common.api';

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    authLogin: build.mutation<LoginResponseDto, AuthLoginDto>({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
    }),
    authLogout: build.mutation<void, AuthLogoutDto>({
      query: (body) => ({
        url: '/auth/logout',
        method: 'POST',
        body,
      }),
    }),
    authRefresh: build.mutation<AuthToken, AuthRefreshDto>({
      query: (body) => ({
        url: '/auth/refresh',
        method: 'POST',
        body,
      }),
    }),
    authCreate: build.mutation<User, AuthCreateDto>({
      query: (body) => ({
        url: '/auth',
        method: 'POST',
        body,
      }),
    }),
    authCreateEmployer: build.mutation<User, EmployerCreateDto>({
      query: (body) => ({
        url: '/auth/employer',
        method: 'POST',
        body,
      }),
    }),
    authCreateJobseeker: build.mutation<Jobseeker, JobseekerCreateDto>({
      query: (body) => ({
        url: '/auth/jobseeker',
        method: 'POST',
        body,
        formData: true,
      }),
    }),
    authCreateExternalOtp: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: '/auth/external-otp',
        method: 'POST',
        body: { email },
      }),
    }),
    authVerifyExternalOtp: build.mutation<void, { email: string; otp: string }>({
      query: ({ email, otp }) => ({
        url: '/auth/verify-external-otp',
        method: 'POST',
        body: { email, otp },
      }),
    }),
    authVerifyOTP: build.mutation<User, AuthVerifyOtpDto>({
      query: (body) => ({
        url: '/auth/verify-otp',
        method: 'POST',
        body,
      }),
    }),
    authRequestPasswordReset: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: '/auth/password-reset',
        method: 'POST',
        body: { email },
      }),
    }),
    authVerifyPasswordResetOtp: build.mutation<void, { email: string; otp: string }>({
      query: ({ email, otp }) => ({
        url: '/auth/verify-password-reset-otp',
        method: 'POST',
        body: { email, otp },
      }),
    }),
    authResetPassword: build.mutation<void, { email: string; otp: string; password: string; confirmPassword: string }>({
      query: ({ email, otp, password, confirmPassword }) => ({
        url: '/auth/password-reset',
        method: 'PATCH',
        body: { email, otp, password, confirmPassword },
      }),
    }),
    authDeleteAccount: build.mutation<void, void>({
      query: () => ({
        url: '/auth/delete-account',
        method: 'DELETE',
      }),
    }),
    authCheckMigrated: build.mutation<boolean, { email: string }>({
      query: (body) => ({
        url: '/auth/check-migrated',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useAuthCreateEmployerMutation,
  useAuthCreateJobseekerMutation,
  useAuthVerifyOTPMutation,
  useAuthCreateExternalOtpMutation,
  useAuthVerifyExternalOtpMutation,
  useAuthRequestPasswordResetMutation,
  useAuthVerifyPasswordResetOtpMutation,
  useAuthResetPasswordMutation,
  useAuthDeleteAccountMutation,
  useAuthCheckMigratedMutation,
} = authApi;
